module.exports = __webpack_public_path__ + "img/UTFLIG.83a49639.png";